import { render, staticRenderFns } from "./DeliveryReport.vue?vue&type=template&id=3328eb4b&scoped=true"
import script from "./DeliveryReport.vue?vue&type=script&lang=js"
export * from "./DeliveryReport.vue?vue&type=script&lang=js"
import style0 from "./DeliveryReport.vue?vue&type=style&index=0&id=3328eb4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3328eb4b",
  null
  
)

export default component.exports